import { defineStore } from 'pinia';
import { paginateUrl } from './helpers';
import axios from 'axios';
import router from '../router';
import eventBus from '../eventBus';

export const useConditionsStore = defineStore('conditions', {
    state: () => ({
        conditions: []
    }),

    getters: {
        condition: (state) => {
            return (id) => state.conditions.find(condition => condition.id == id);
        },
    },

    actions: {
        _upsertCondition(payload) {
            const idx = this.conditions.findIndex(c => c.id === payload.id);
            if (idx !== -1) {
                this.conditions[idx] = payload;
            } else {
                this.conditions.push(payload);
            }
        },

        initConditions() {
            this.conditions = [];
        },

        async createCondition(payload) {
            try {
                const response = await axios.post("/v1/conditions", payload);
                this.conditions.push(response.data.data);
                return response.data;
            } catch (error) {
                throw error.response ?? error;
            }
        },

        async updateCondition(payload) {
            try {
                const response = await axios.put("/v1/conditions/" + payload.condition.id, payload.condition);
                this._upsertCondition(response.data.data);
                return response.data;
            } catch (error) {
                throw error.response ?? error;
            }
        },

        async readCondition(payload) {
            try {
                const response = await axios.get('/v1/conditions/' + payload.condition.id);
                this._upsertCondition(response.data.data);
                return response.data;
            } catch (error) {
                if (error.response?.status == 404) {
                    const idx = this.conditions.findIndex(c => c.id === payload.condition.id);
                    if (idx !== -1) this.conditions.splice(idx, 1);
                    eventBus.emit("SHOW_ALERT", { status: 404, data: { message: "This condition is no longer available" } });
                    await router.push('/conditions');
                    return;
                }
                throw error.response ?? error;
            }
        },

        async deleteCondition(payload) {
            try {
                const response = await axios.delete("/v1/conditions/" + payload.condition.id);
                const idx = this.conditions.findIndex(c => c.id === payload.condition.id);
                if (idx !== -1) this.conditions.splice(idx, 1);
                return response.data;
            } catch (error) {
                throw error.response ?? error;
            }
        },

        async readConditions(payload) {
            const requestUrl = paginateUrl('/v1/conditions/?', payload.pagination);
            try {
                const response = await axios.get(requestUrl);
                const conditions = response.data.data;
                conditions.forEach(condition => {
                    this._upsertCondition(condition);
                });
                return response.data;
            } catch (error) {
                throw error.response ?? error;
            }
        },

        async readDataSourceResponse(payload) {
            try {
                const response = await axios.get("/v1/datasource/" + payload.data_source.id);
                return response.data;
            } catch (error) {
                throw error.response ?? error;
            }
        },

        async testDataSource(payload) {
            try {
                const response = await axios.post('/v1/datasource/test', payload);
                return response.data;
            } catch (error) {
                throw error.response ?? error;
            }
        },
    },

});
